(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["adspoc-about"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('adspoc-about')) return;
    /* Timeline: arrows slide a card at a time; the first card in view is "in focus" (yellow); counter shows 01–04 / 08.
       Phone: vertical list, "Show all" reveals the rest. */
    class AdspocAbout extends HTMLElement {
      connectedCallback() {
        if (this.dataset.module !== 'timeline' || this._bound) return;
        this._bound = true;
        this.track = this.querySelector('[data-tl-track]');
        this.cards = [...this.querySelectorAll('[data-tl-card]')];
        this.count = this.querySelector('[data-tl-count]');
        this.addEventListener('click', (e) => {
          const s = e.target.closest('[data-tl-step]');
          if (s) { this.step(Number(s.dataset.tlStep)); return; }
          const m = e.target.closest('[data-tl-more]');
          if (m) {
            const tl = this.querySelector('.adspoc-ab__tl');
            const all = !tl.classList.contains('is-all');
            tl.classList.toggle('is-all', all);
            m.setAttribute('aria-expanded', String(all));
          }
        });
        if (this.track) {
          this.track.addEventListener('scroll', () => { cancelAnimationFrame(this._raf); this._raf = requestAnimationFrame(() => this.sync()); }, { passive: true });
          this._onResize = () => this.sync();
          window.addEventListener('resize', this._onResize);
        }
        this.addEventListener('shopify:block:select', (e) => {
          const c = e.target.closest('[data-tl-card]');
          if (c && this.track) this.track.scrollTo({ left: c.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
        });
        requestAnimationFrame(() => this.sync());
      }
      disconnectedCallback() { if (this._onResize) window.removeEventListener('resize', this._onResize); this._bound = false; }
      step(dir) {
        const t = this.track; if (!t || !this.cards.length) return;
        const gap = parseFloat(getComputedStyle(t).columnGap) || 24;
        const w = this.cards[0].getBoundingClientRect().width + gap;
        const max = t.scrollWidth - t.clientWidth;
        t.scrollTo({ left: Math.max(0, Math.min(max, t.scrollLeft + dir * w)), behavior: 'smooth' });
      }
      sync() {
        const t = this.track; if (!t || !this.cards.length) return;
        const tr = t.getBoundingClientRect();
        const visible = this.cards.map((c, i) => ({ i, r: c.getBoundingClientRect() })).filter((o) => o.r.left >= tr.left - 4 && o.r.right <= tr.right + 4);
        const first = visible.length ? visible[0].i : 0;
        const last = visible.length ? visible[visible.length - 1].i : 0;
        this.cards.forEach((c, i) => c.classList.toggle('is-focus', i === first));
        const pad = (n) => String(n).padStart(2, '0');
        if (this.count) this.count.innerHTML = pad(first + 1) + (last > first ? '–' + pad(last + 1) : '') + ' <span>/ ' + pad(this.cards.length) + '</span>';
        const max = t.scrollWidth - t.clientWidth;
        const [prev, next] = this.querySelectorAll('[data-tl-step]');
        const arrows = this.querySelector('[data-tl-arrows]');
        if (arrows) arrows.closest('.adspoc-ab__tl-nav').hidden = max <= 4;
        if (prev) prev.disabled = t.scrollLeft <= 4;
        if (next) next.disabled = t.scrollLeft >= max - 4;
      }
    }
    customElements.define('adspoc-about', AdspocAbout);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["adspoc-aboutus"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('adspoc-about')) return;
    /* Timeline: arrows slide a card at a time; the first card in view is "in focus" (yellow); counter shows 01–04 / 08.
       Phone: vertical list, "Show all" reveals the rest. */
    class AdspocAbout extends HTMLElement {
      connectedCallback() {
        if (this.dataset.module !== 'timeline' || this._bound) return;
        this._bound = true;
        this.track = this.querySelector('[data-tl-track]');
        this.cards = [...this.querySelectorAll('[data-tl-card]')];
        this.count = this.querySelector('[data-tl-count]');
        this.addEventListener('click', (e) => {
          const s = e.target.closest('[data-tl-step]');
          if (s) { this.step(Number(s.dataset.tlStep)); return; }
          const m = e.target.closest('[data-tl-more]');
          if (m) {
            const tl = this.querySelector('.adspoc-ab__tl');
            const all = !tl.classList.contains('is-all');
            tl.classList.toggle('is-all', all);
            m.setAttribute('aria-expanded', String(all));
          }
        });
        if (this.track) {
          this.track.addEventListener('scroll', () => { cancelAnimationFrame(this._raf); this._raf = requestAnimationFrame(() => this.sync()); }, { passive: true });
          this._onResize = () => this.sync();
          window.addEventListener('resize', this._onResize);
        }
        this.addEventListener('shopify:block:select', (e) => {
          const c = e.target.closest('[data-tl-card]');
          if (c && this.track) this.track.scrollTo({ left: c.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
        });
        requestAnimationFrame(() => this.sync());
      }
      disconnectedCallback() { if (this._onResize) window.removeEventListener('resize', this._onResize); this._bound = false; }
      step(dir) {
        const t = this.track; if (!t || !this.cards.length) return;
        const gap = parseFloat(getComputedStyle(t).columnGap) || 24;
        const w = this.cards[0].getBoundingClientRect().width + gap;
        const max = t.scrollWidth - t.clientWidth;
        t.scrollTo({ left: Math.max(0, Math.min(max, t.scrollLeft + dir * w)), behavior: 'smooth' });
      }
      sync() {
        const t = this.track; if (!t || !this.cards.length) return;
        const tr = t.getBoundingClientRect();
        const visible = this.cards.map((c, i) => ({ i, r: c.getBoundingClientRect() })).filter((o) => o.r.left >= tr.left - 4 && o.r.right <= tr.right + 4);
        const first = visible.length ? visible[0].i : 0;
        const last = visible.length ? visible[visible.length - 1].i : 0;
        this.cards.forEach((c, i) => c.classList.toggle('is-focus', i === first));
        const pad = (n) => String(n).padStart(2, '0');
        if (this.count) this.count.innerHTML = pad(first + 1) + (last > first ? '–' + pad(last + 1) : '') + ' <span>/ ' + pad(this.cards.length) + '</span>';
        const max = t.scrollWidth - t.clientWidth;
        const [prev, next] = this.querySelectorAll('[data-tl-step]');
        const arrows = this.querySelector('[data-tl-arrows]');
        if (arrows) arrows.closest('.adspoc-ab__tl-nav').hidden = max <= 4;
        if (prev) prev.disabled = t.scrollLeft <= 4;
        if (next) next.disabled = t.scrollLeft >= max - 4;
      }
    }
    customElements.define('adspoc-about', AdspocAbout);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["adspoc-bulk-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('adspoc-bulk-popup')) {
    customElements.define('adspoc-bulk-popup', class extends HTMLElement {
      connectedCallback() {
        this.d = this.querySelector('dialog');
        this.form = this.querySelector('form');
        this.done = this.querySelector('[data-bq-done]');
        this.hash = '#' + this.dataset.hash;
        this.calm = matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.onDoc = (e) => {
          const a = e.target.closest('[data-bq-open], a[href]');
          if (!a) return;
          const href = a.getAttribute('href') || '';
          if (a.hasAttribute('data-bq-open') || href === this.hash || href.endsWith('/' + this.hash) || href.endsWith(this.hash)) {
            e.preventDefault();
            this.open(a);
          }
        };
        document.addEventListener('click', this.onDoc);
        this.d.addEventListener('cancel', (e) => { e.preventDefault(); this.close(); });
        this.d.addEventListener('click', (e) => { if (e.target === this.d) this.close(); });
        this.querySelectorAll('[data-bq-close]').forEach((b) => b.addEventListener('click', () => this.close()));

        const date = this.querySelector('[data-bq-date]');
        if (date) date.min = new Date().toISOString().slice(0, 10);
        const page = this.querySelector('[data-bq-page]');
        if (page) page.value = location.href.split('#')[0];

        this.form.addEventListener('input', (e) => { const f = e.target.closest('.adspoc-bq__f'); if (f) f.classList.remove('is-bad'); });
        this.form.addEventListener('submit', (e) => this.send(e));

        // came back from Shopify's own page (spam check or an error): reopen in the right state
        let flag = null;
        try { flag = sessionStorage.getItem('adspoc-bq'); sessionStorage.removeItem('adspoc-bq'); } catch (err) {}
        const posted = /[?&]contact_posted=true/.test(location.search);
        if (flag && posted) { this.open(); this.showDone(flag); }
        else if (flag) { this.open(); }
        else if (location.hash === this.hash) { this.open(); }

        if (window.Shopify && Shopify.designMode) {
          document.addEventListener('shopify:section:select', (e) => { if (e.detail.sectionId === this.dataset.section) this.open(); });
          document.addEventListener('shopify:section:deselect', (e) => { if (e.detail.sectionId === this.dataset.section) this.close(); });
        }
      }
      disconnectedCallback() { document.removeEventListener('click', this.onDoc); }

      open(trigger) {
        if (this.d.open) return;
        this.trigger = trigger;
        const need = trigger && trigger.dataset ? trigger.dataset.bqNeed : '';
        if (need) this.querySelectorAll('[data-bq-need]').forEach((c) => { if (c.value.toLowerCase() === need.toLowerCase()) c.checked = true; });
        clearTimeout(this.t);
        this.d.dataset.state = 'in';
        this.d.showModal();
        this.querySelector('.adspoc-bq__main').scrollTop = 0;
        this.t = setTimeout(() => { this.d.dataset.state = 'open'; }, this.calm ? 250 : 1700);
      }

      close() {
        if (!this.d.open || this.d.dataset.state === 'out') return;
        clearTimeout(this.t);
        this.d.dataset.state = 'out';
        this.t = setTimeout(() => {
          this.d.close();
          delete this.d.dataset.state;
          if (location.hash === this.hash) history.replaceState(null, '', location.pathname + location.search);
          if (this.trigger && this.trigger.focus) this.trigger.focus({ preventScroll: true });
        }, this.calm ? 200 : 900);
      }

      check() {
        let first = null;
        this.form.querySelectorAll('[required]').forEach((el) => {
          let ok = el.value.trim() !== '';
          if (ok && el.type === 'email') ok = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(el.value.trim());
          if (ok && el.hasAttribute('data-bq-phone')) ok = el.value.replace(/\D/g, '').length >= 10;
          const f = el.closest('.adspoc-bq__f');
          f.classList.toggle('is-bad', !ok);
          if (!ok) { void f.offsetWidth; if (!first) first = el; }
        });
        if (first) { first.focus(); first.scrollIntoView({ block: 'center', behavior: 'smooth' }); }
        return !first;
      }

      send(e) {
        e.preventDefault();
        if (!this.check()) return;
        const out = this.querySelector('[data-bq-need-out]');
        if (out) out.value = [...this.querySelectorAll('[data-bq-need]:checked')].map((c) => c.value).join(', ') || '-';
        const btn = this.form.querySelector('[type="submit"]');
        const fail = this.querySelector('[data-bq-fail]');
        const name = (this.form.querySelector('[name="contact[Name]"]').value || '').trim().split(' ')[0];
        btn.setAttribute('aria-busy', 'true');
        fail.hidden = true;
        const native = () => {
          try { sessionStorage.setItem('adspoc-bq', name || '1'); } catch (err) {}
          HTMLFormElement.prototype.submit.call(this.form);
        };
        fetch(this.form.action, { method: 'POST', body: new FormData(this.form), headers: { Accept: 'text/html' } })
          .then((r) => {
            if (r.ok && /contact_posted=true/.test(r.url)) { this.showDone(name); }
            else { native(); }
          })
          .catch(() => { btn.removeAttribute('aria-busy'); fail.hidden = false; });
      }

      showDone(name) {
        const h = this.done.querySelector('[data-bq-done-title]');
        const tpl = h.dataset.template || '';
        const who = name && name !== '1' ? name : '';
        h.textContent = who ? tpl.replace('[name]', who) : tpl.replace(/,?\s*\[name\]/, '');
        this.form.hidden = true;
        this.done.hidden = false;
        this.done.classList.add('is-in');
        this.done.focus({ preventScroll: true });
        const btn = this.form.querySelector('[type="submit"]');
        btn.removeAttribute('aria-busy');
        try {
          if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('adspoc_bulk_enquiry', {});
          if (window.gtag) gtag('event', 'generate_lead', { form: 'bulk_order' });
          (window.dataLayer = window.dataLayer || []).push({ event: 'adspoc_bulk_enquiry' });
        } catch (err) {}
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["adspoc-cart-drawer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('adspoc-cart')) return;
    const root = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    // Keep the browser's own fetch for the drawer's requests, so they don't trigger the interceptor below
    const nativeFetch = window.__adspocNativeFetch || window.fetch.bind(window);
    window.__adspocNativeFetch = nativeFetch;

    class AdspocCart extends HTMLElement {
      connectedCallback() {
        if (this._bound) return;
        this._bound = true;
        this.panel = this.querySelector('.adspoc-cart__panel');
        this.recCache = new Map();
        this.onDocClick = this.onDocClick.bind(this);
        this.onKey = this.onKey.bind(this);
        this.onCartEvent = () => { if (!this._self) this.refresh(false); };
        this.onQv = () => this.close(true);
        document.addEventListener('click', this.onDocClick);
        this.addEventListener('scroll', (e) => {
          if (!e.target.matches || !e.target.matches('.adspoc-cart__rail, [data-review-track]')) return;
          cancelAnimationFrame(this._arrowRaf);
          this._arrowRaf = requestAnimationFrame(() => this.syncArrows());
        }, true);
        document.addEventListener('keydown', this.onKey);
        document.addEventListener('adspoc:quickview-open', this.onQv);
        ['cart:updated', 'cart:refresh'].forEach((t) => {
          window.addEventListener(t, this.onCartEvent);
          document.documentElement.addEventListener(t, this.onCartEvent);
        });
        this.installInterceptor();
        this.expose();
        this.afterRender();
      }
      disconnectedCallback() {
        document.removeEventListener('click', this.onDocClick);
        document.removeEventListener('keydown', this.onKey);
        document.removeEventListener('adspoc:quickview-open', this.onQv);
        ['cart:updated', 'cart:refresh'].forEach((t) => {
          window.removeEventListener(t, this.onCartEvent);
          document.documentElement.removeEventListener(t, this.onCartEvent);
        });
        clearInterval(this._quoteTimer);
        this._bound = false;
      }

      expose() {
        const self = this;
        window.AdspocCart = { open: () => self.open(), close: () => self.close(), refresh: (o) => self.refresh(o) };
        // Old helpers, kept for anything that still calls them
        window.updateCartQuantity = (key, qty) => self.change(key, qty);
        window.addUpsellToCart = (variantId) => nativeFetch(root() + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        }).then(() => self.refresh(true));
      }

      /* Any add / change / update / clear to /cart from anywhere (product page, quick view, apps)
         refreshes the drawer and opens it. Same rule as the old header. */
      installInterceptor() {
        if (window.__adspocCartPatched) return;
        window.__adspocCartPatched = true;
        window.fetch = async function (...args) {
          const input = args[0];
          const url = typeof input === 'string' ? input : (input && input.url);
          const res = await nativeFetch(...args);
          try {
            if (url && res.ok) {
              const u = new URL(url, location.origin);
              if (u.origin === location.origin && /\/cart\/(add|change|update|clear)(\.js)?$/i.test(u.pathname)) {
                const el = document.querySelector('adspoc-cart');
                if (el) el.refresh(true);
              }
            }
          } catch (e) { /* never block the page's own request */ }
          return res;
        };
      }

      /* ----- open / close ----- */
      open() {
        if (this.classList.contains('is-open')) return;
        this._last = document.activeElement;
        this.classList.add('is-open');
        document.documentElement.style.overflow = 'hidden';
        document.documentElement.classList.add('adspoc-cart-open');
        const x = this.querySelector('.adspoc-cart__x');
        setTimeout(() => (x || this.panel).focus({ preventScroll: true }), 50);
        this.loadRecs();
        setTimeout(() => this.syncArrows(), 60);
      }
      close(silent) {
        if (!this.classList.contains('is-open')) return;
        this.classList.remove('is-open');
        document.documentElement.style.overflow = '';
        document.documentElement.classList.remove('adspoc-cart-open');
        this.collapseSummary();
        if (!silent && this._last && this._last.focus) this._last.focus({ preventScroll: true });
      }

      onDocClick(e) {
        const t = e.target;
        if (t.closest('[data-cart-open], .js-cart-open')) { e.preventDefault(); this.open(); return; }
        if (!this.contains(t)) return;
        if (t.closest('[data-cart-close]')) { e.preventDefault(); this.close(); return; }
        const q = t.closest('[data-cart-qty]');
        if (q) { e.preventDefault(); this.change(q.dataset.key, Number(q.dataset.qty)); return; }
        const step = t.closest('[data-review-step]');
        if (step) { this.stepTrack(this.querySelector('[data-review-track]'), Number(step.dataset.reviewStep)); return; }
        const rstep = t.closest('[data-rail-step]');
        if (rstep) { const wrap = rstep.closest('.adspoc-cart__rail-wrap'); this.stepTrack(wrap && wrap.querySelector('.adspoc-cart__rail'), Number(rstep.dataset.railStep)); return; }
        const toggle = t.closest('.js-summary-toggle');
        if (toggle) {
          e.preventDefault();
          const open = toggle.getAttribute('aria-expanded') !== 'true';
          toggle.setAttribute('aria-expanded', String(open));
          toggle.closest('.js-summary-wrapper').classList.toggle('is-expanded', open);
          return;
        }
        if (!t.closest('.js-summary-wrapper')) this.collapseSummary();
      }
      collapseSummary() {
        const w = this.querySelector('.js-summary-wrapper.is-expanded');
        if (!w) return;
        w.classList.remove('is-expanded');
        const tg = w.querySelector('.js-summary-toggle'); if (tg) tg.setAttribute('aria-expanded', 'false');
      }
      onKey(e) {
        if (!this.classList.contains('is-open')) return;
        if (e.key === 'Escape') { e.preventDefault(); this.close(); return; }
        if (e.key !== 'Tab') return;
        const f = [...this.panel.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]), [tabindex="0"]')].filter((n) => n.offsetParent !== null);
        if (!f.length) return;
        if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      }

      /* ----- data ----- */
      /* Many signals can arrive together (interceptor + cart:updated + cart:refresh, on window and
         document); they are folded into one request, and the drawer opens if any of them asked to. */
      refresh(openAfter) {
        if (openAfter) this._openPending = true;
        clearTimeout(this._refreshT);
        return new Promise((resolve) => {
          this._refreshT = setTimeout(() => this.doRefresh().then(resolve), 60);
        });
      }

      async doRefresh() {
        const token = (this._token = {});
        try {
          const [htmlRes, cartRes] = await Promise.all([
            nativeFetch(root() + '?section_id=' + encodeURIComponent(this.dataset.sectionId)),
            nativeFetch(root() + 'cart.js')
          ]);
          const html = await htmlRes.text();
          const cart = await cartRes.json();
          if (token !== this._token) return;
          window.cart = cart;
          this.swap(html, cart);
        } catch (e) { /* keep what is on screen */ }
        if (token !== this._token) return;
        if (this._openPending) { this._openPending = false; this.open(); }
      }

      async change(key, qty) {
        if (!key || qty < 0) return;
        this.setAttribute('aria-busy', 'true');
        const err = this.querySelector('[data-cart-error]');
        try {
          const res = await nativeFetch(root() + 'cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: key, quantity: qty, sections: [this.dataset.sectionId], sections_url: window.location.pathname })
          });
          const data = await res.json();
          if (!res.ok) throw new Error(data.description || data.message || 'Could not update the cart.');
          const html = data.sections && data.sections[this.dataset.sectionId];
          delete data.sections;
          window.cart = data;
          if (html) this.swap(html, data); else await this.doRefresh();
          this._self = true;
          document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
          this._self = false;
        } catch (e) {
          if (err) { err.textContent = e.message; err.hidden = false; }
        } finally {
          this.removeAttribute('aria-busy');
        }
      }

      /* Swap in a fresh render. The footer (form + Shiprocket slot) stays; only its numbers change. */
      swap(html, cart) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('adspoc-cart');
        if (!fresh) return;
        const pick = (sel) => [this.querySelector(sel), fresh.querySelector(sel)];
        const [live, liveNew] = pick('[data-cart-live]');
        if (live && liveNew) {
          const scroll = live.scrollTop;
          const keepRecs = this.querySelector('[data-cart-recs]');
          live.innerHTML = liveNew.innerHTML;
          live.scrollTop = scroll;
          // Keep already-loaded recommendations if the first product didn't change
          const recs = live.querySelector('[data-cart-recs]');
          if (recs && keepRecs && keepRecs.dataset.productId === recs.dataset.productId && keepRecs.innerHTML.trim()) recs.innerHTML = keepRecs.innerHTML;
        }
        const [sum, sumNew] = pick('[data-cart-summary]');
        if (sum && sumNew) sum.innerHTML = sumNew.innerHTML;
        [['[data-cart-subtotal]', 'textContent'], ['[data-cart-count-text]', 'textContent']].forEach(([sel, prop]) => {
          const [a, b] = pick(sel); if (a && b) a[prop] = b[prop];
        });
        const [sav, savNew] = pick('[data-cart-saving]');
        if (sav && savNew) { sav.textContent = savNew.textContent; sav.hidden = savNew.hidden; }
        const foot = this.querySelector('[data-cart-foot]');
        if (foot && cart) foot.hidden = cart.item_count === 0;
        if (cart) {
          document.querySelectorAll('.js-cart-count, [data-cart-count]').forEach((el) => {
            el.textContent = cart.item_count;
            el.dataset.count = cart.item_count;
          });
        }
        this.afterRender();
      }

      afterRender() {
        if (this.classList.contains('is-open')) this.loadRecs();
        this.startQuotes();
        requestAnimationFrame(() => this.syncArrows());
      }

      /* Recommendations: rendered by Shopify into this same section, for the first product in the cart */
      async loadRecs() {
        const box = this.querySelector('[data-cart-recs]');
        if (!box || box.innerHTML.trim() || !box.dataset.productId) return;
        const id = box.dataset.productId;
        if (this.recCache.has(id)) { box.innerHTML = this.recCache.get(id); this.syncArrows(); return; }
        try {
          const url = root() + 'recommendations/products?product_id=' + encodeURIComponent(id) +
            '&limit=' + (Number(this.dataset.recLimit || 4) + 2) +
            '&intent=' + encodeURIComponent(this.dataset.recIntent || 'related') +
            '&section_id=' + encodeURIComponent(this.dataset.sectionId);
          const res = await nativeFetch(url);
          if (!res.ok) return;
          const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
          const got = doc.querySelector('[data-cart-recs]');
          const inner = got ? got.innerHTML.trim() : '';
          this.recCache.set(id, inner);
          const now = this.querySelector('[data-cart-recs]');
          if (now && now.dataset.productId === id) { now.innerHTML = inner; this.syncArrows(); }
        } catch (e) { /* no cards, no problem */ }
      }

      stepTrack(track, dir) {
        if (!track || !track.firstElementChild) return;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 10;
        const w = track.firstElementChild.getBoundingClientRect().width + gap;
        const max = track.scrollWidth - track.clientWidth;
        const next = Math.max(0, Math.min(max, track.scrollLeft + dir * w));
        track.scrollTo({ left: next, behavior: 'smooth' });
      }

      /* Arrows: back is off at the start, next is off at the end; both hide when everything fits */
      syncArrows() {
        this.querySelectorAll('.adspoc-cart__rail, [data-review-track]').forEach((track) => {
          const box = track.closest('.adspoc-cart__rail-wrap, .adspoc-cart__reviews');
          const arrows = box && box.querySelector('.adspoc-cart__arrows');
          if (!arrows) return;
          const max = track.scrollWidth - track.clientWidth;
          const [prev, next] = arrows.querySelectorAll('button');
          arrows.hidden = max <= 4;
          if (prev) prev.disabled = track.scrollLeft <= 4;
          if (next) next.disabled = track.scrollLeft >= max - 4;
        });
      }

      startQuotes() {
        clearInterval(this._quoteTimer);
        const lines = [...this.querySelectorAll('.adspoc-cart__quote-line')];
        if (lines.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        let i = 0;
        this._quoteTimer = setInterval(() => {
          lines[i].classList.remove('is-on');
          i = (i + 1) % lines.length;
          lines[i].classList.add('is-on');
        }, 5000);
      }
    }
    customElements.define('adspoc-cart', AdspocCart);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["adspoc-collection-showcase"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('adspoc-coll-showcase')) return;
    /* Tiles row arrows: off at the ends, hidden when everything fits */
    class AdspocCollShowcase extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-cs-track]');
        this.arrows = this.querySelector('[data-cs-arrows]');
        if (!this.track || !this.arrows || this._bound) return;
        this._bound = true;
        this.arrows.addEventListener('click', (e) => {
          const b = e.target.closest('[data-cs-step]');
          if (!b || !this.track.firstElementChild) return;
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 16;
          const w = (this.track.firstElementChild.getBoundingClientRect().width + gap) * 2;
          const max = this.track.scrollWidth - this.track.clientWidth;
          this.track.scrollTo({ left: Math.max(0, Math.min(max, this.track.scrollLeft + Number(b.dataset.csStep) * w)), behavior: 'smooth' });
        });
        this.track.addEventListener('scroll', () => { cancelAnimationFrame(this._raf); this._raf = requestAnimationFrame(() => this.sync()); }, { passive: true });
        this._onResize = () => this.sync();
        window.addEventListener('resize', this._onResize);
        requestAnimationFrame(() => this.sync());
      }
      disconnectedCallback() { if (this._onResize) window.removeEventListener('resize', this._onResize); this._bound = false; }
      sync() {
        const t = this.track; const max = t.scrollWidth - t.clientWidth;
        const [prev, next] = this.arrows.querySelectorAll('button');
        this.arrows.hidden = max <= 4;
        prev.disabled = t.scrollLeft <= 4;
        next.disabled = t.scrollLeft >= max - 4;
      }
    }
    customElements.define('adspoc-coll-showcase', AdspocCollShowcase);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["adspoc-contact"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('adspoc-contact')) {
    customElements.define('adspoc-contact', class extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.wrap = this.querySelector('[data-ct-form-wrap]');
        this.done = this.querySelector('[data-ct-done]');
        this.msg = this.querySelector('[data-ct-msg]');
        if (this.form) {
          const want = new URLSearchParams(location.search).get('topic') || (location.hash === '#bulk' ? 'bulk' : '');
          if (want) { const r = this.form.querySelector('[data-topic="' + want + '"]'); if (r) r.checked = true; }
          this.form.addEventListener('change', (e) => { if (e.target.matches('[data-topic]')) this.setTopic(); });
          this.form.addEventListener('input', (e) => { const f = e.target.closest('.adspoc-ct__f'); if (f) f.classList.remove('is-bad'); });
          this.form.addEventListener('submit', (e) => this.send(e));
          this.setTopic();
          let flag = null;
          try { flag = sessionStorage.getItem('adspoc-ct'); sessionStorage.removeItem('adspoc-ct'); } catch (err) {}
          if (flag && /[?&]contact_posted=true/.test(location.search)) this.showDone(flag);
          if (flag || want) this.querySelector('#contact-form').scrollIntoView({ block: 'start' });
        }
        const again = this.querySelector('[data-ct-again]');
        if (again) again.addEventListener('click', () => { this.form.reset(); this.setTopic(); this.done.hidden = true; this.wrap.hidden = false; });
        this.querySelectorAll('[data-ct-copy]').forEach((b) => b.addEventListener('click', () => {
          const t = b.dataset.ctCopy; const lbl = b.querySelector('span');
          const ok = () => { b.classList.add('is-done'); if (lbl) lbl.textContent = 'Copied'; clearTimeout(b._t); b._t = setTimeout(() => { b.classList.remove('is-done'); if (lbl) lbl.textContent = 'Copy'; }, 1600); };
          if (navigator.clipboard) navigator.clipboard.writeText(t).then(ok, ok); else ok();
        }));
        this.openBadge();
      }

      topic() { const r = this.form.querySelector('[data-topic]:checked'); return r ? r.dataset.topic : 'other'; }
      setTopic() {
        const t = this.topic();
        this.form.dataset.topic = t;
        if (this.msg) this.msg.placeholder = this.msg.dataset['ph' + t.charAt(0).toUpperCase() + t.slice(1)] || '';
      }

      check() {
        let first = null;
        this.form.querySelectorAll('[required]').forEach((el) => {
          let ok = el.value.trim() !== '';
          if (ok && el.type === 'email') ok = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(el.value.trim());
          if (ok && el.hasAttribute('data-ct-phone')) ok = el.value.replace(/\D/g, '').length >= 10;
          const f = el.closest('.adspoc-ct__f'); f.classList.toggle('is-bad', !ok);
          if (!ok && !first) first = el;
        });
        if (first) { first.focus(); first.scrollIntoView({ block: 'center', behavior: 'smooth' }); }
        return !first;
      }

      send(e) {
        e.preventDefault();
        if (!this.check()) return;
        const t = this.topic();
        /* only send the fields this topic shows */
        this.form.querySelectorAll('[data-only]').forEach((g) => {
          const on = g.dataset.only === t;
          g.querySelectorAll('input, textarea, select').forEach((el) => { el.disabled = !on; });
        });
        const out = this.form.querySelector('[data-ct-need-out]');
        const picked = [...this.form.querySelectorAll('[data-ct-need]:checked')].map((c) => c.value);
        if (out) { out.disabled = !(t === 'bulk' && picked.length); out.value = picked.join(', '); }
        this.form.querySelectorAll('[data-ct-need]').forEach((c) => { c.disabled = true; });
        const fd = new FormData(this.form);
        this.form.querySelectorAll('[data-only] input, [data-only] textarea, [data-ct-need]').forEach((el) => { el.disabled = false; });
        const btn = this.form.querySelector('[type="submit"]');
        const fail = this.querySelector('[data-ct-fail]');
        const name = ((this.form.querySelector('[name="contact[Name]"]') || {}).value || '').trim().split(' ')[0];
        btn.setAttribute('aria-busy', 'true'); fail.hidden = true;
        const native = () => {
          try { sessionStorage.setItem('adspoc-ct', name || '1'); } catch (err) {}
          this.form.querySelectorAll('[data-only]').forEach((g) => { if (g.dataset.only !== t) g.querySelectorAll('input, textarea').forEach((el) => { el.disabled = true; }); });
          this.form.querySelectorAll('[data-ct-need]').forEach((c) => { c.disabled = true; });
          HTMLFormElement.prototype.submit.call(this.form);
        };
        fetch(this.form.action, { method: 'POST', body: fd, headers: { Accept: 'text/html' } })
          .then((r) => { if (r.ok && /contact_posted=true/.test(r.url)) this.showDone(name); else native(); })
          .catch(() => { btn.removeAttribute('aria-busy'); fail.hidden = false; });
      }

      showDone(name) {
        const h = this.done.querySelector('[data-ct-done-title]');
        const tpl = h.dataset.template || '';
        const who = name && name !== '1' ? name : '';
        h.textContent = who ? tpl.replace('[name]', who) : tpl.replace(/,?\s*\[name\]/, '');
        const btn = this.form.querySelector('[type="submit"]'); btn.removeAttribute('aria-busy');
        this.wrap.hidden = true; this.done.hidden = false; this.done.focus({ preventScroll: true });
        try {
          if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('adspoc_contact_message', { topic: this.topic() });
          if (window.gtag) gtag('event', 'generate_lead', { form: 'contact_' + this.topic() });
        } catch (err) {}
      }

      openBadge() {
        const b = this.querySelector('[data-ct-open]');
        const open = Number(this.dataset.open), close = Number(this.dataset.close);
        if (!b || !(close > open)) return;
        try {
          const parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Asia/Kolkata', weekday: 'short', hour: 'numeric', minute: 'numeric', hourCycle: 'h23' }).formatToParts(new Date());
          const get = (t) => (parts.find((p) => p.type === t) || {}).value;
          const h = Number(get('hour')) + Number(get('minute')) / 60;
          const day = (get('weekday') || '').toLowerCase().slice(0, 3);
          const isOpen = day !== (this.dataset.closedDay || '').slice(0, 3) && h >= open && h < close;
          b.textContent = isOpen ? 'Open now' : 'Closed now'; b.classList.toggle('is-closed', !isOpen); b.hidden = false;
        } catch (e) {}
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["adspoc-customheader"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('adspoc-header')) return;
    const nativeFetch = () => window.__adspocNativeFetch || window.fetch.bind(window);
    const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
    const mark = (text, q) => {
      const t = esc(text);
      if (!q) return t;
      const safe = esc(q).replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
      return t.replace(new RegExp('(' + safe + ')', 'gi'), '<mark>$1</mark>');
    };
    const rupees = (v) => {
      const n = parseFloat(String(v ?? '').replace(/[^\d.]/g, ''));
      if (!isFinite(n)) return '';
      return '₹' + n.toLocaleString('en-IN', { maximumFractionDigits: n % 1 ? 2 : 0 });
    };
    const isPhone = () => window.matchMedia('(max-width: 989px)').matches;

    class AdspocHeader extends HTMLElement {
      connectedCallback() {
        if (this._bound) return;
        this._bound = true;
        this.form = this.querySelector('[data-hdr-search]');
        this.input = this.querySelector('[data-hdr-search-input]');
        this.results = this.querySelector('[data-hdr-results]');
        this.dim = this.querySelector('[data-hdr-dim]');
        this.tabs = this.querySelector('[data-tabs-scroll]');
        this.panelBox = this.querySelector('[data-tab-panel-box]');
        this.menu = this.querySelector('.adspoc-hdr__menu');

        this.addEventListener('click', (e) => this.onClick(e));
        this.onDocClick = (e) => { if (!this.contains(e.target)) { this.closeSearch(); this.hidePanel(); } };
        this.onKey = (e) => this.handleKey(e);
        document.addEventListener('click', this.onDocClick);
        document.addEventListener('keydown', this.onKey);

        if (this.input) {
          this.input.addEventListener('input', () => this.onType());
          this.input.addEventListener('focus', () => { if (this.input.value.trim()) { if (isPhone()) this.openSearch(); else this.onType(); } });
          this.input.addEventListener('keydown', (e) => this.searchKeys(e));
        }
        if (this.dim) this.dim.addEventListener('click', () => this.closeSearch());

        if (this.tabs) {
          this.updateArrows = this.updateArrows.bind(this);
          this.tabs.addEventListener('scroll', this.updateArrows, { passive: true });
          window.addEventListener('resize', this.updateArrows);
          this.updateArrows();
          this.querySelectorAll('[data-tab-panel]').forEach((tab) => {
            tab.addEventListener('mouseenter', () => { clearTimeout(this._hideT); this.showPanel(tab); });
            tab.addEventListener('focus', () => this.showPanel(tab));
            tab.addEventListener('mouseleave', () => this.queueHide());
          });
          if (this.panelBox) {
            this.panelBox.addEventListener('mouseenter', () => clearTimeout(this._hideT));
            this.panelBox.addEventListener('mouseleave', () => this.queueHide());
          }
        }
      }
      disconnectedCallback() {
        document.removeEventListener('click', this.onDocClick);
        document.removeEventListener('keydown', this.onKey);
        if (this.updateArrows) window.removeEventListener('resize', this.updateArrows);
        this._bound = false;
      }

      onClick(e) {
        const t = e.target;
        if (t.closest('[data-hdr-menu-open]')) { this.openMenu(); return; }
        if (t.closest('[data-hdr-menu-close]')) { this.closeMenu(); return; }
        if (t.closest('[data-hdr-search-close]')) { e.preventDefault(); this.closeSearch(); return; }
        const step = t.closest('[data-tabs-step]');
        if (step) { this.tabs.scrollBy({ left: Number(step.dataset.tabsStep) * 320, behavior: 'smooth' }); return; }
        const dept = t.closest('.adspoc-hdr__dept > .adspoc-hdr__dept-btn');
        if (dept) {
          const open = dept.getAttribute('aria-expanded') !== 'true';
          dept.setAttribute('aria-expanded', String(open));
          const panel = document.getElementById(dept.getAttribute('aria-controls'));
          if (panel) panel.hidden = !open;
        }
      }
      handleKey(e) {
        if (e.key !== 'Escape') {
          if (e.key === 'Tab' && this.classList.contains('menu-open')) this.trap(e, this.menu);
          return;
        }
        if (this.classList.contains('menu-open')) this.closeMenu();
        if (this.form && (this.form.classList.contains('is-open') || !this.results.hidden)) { this.closeSearch(); this.input.blur(); }
        this.hidePanel();
      }
      trap(e, box) {
        const f = [...box.querySelectorAll('a[href], button:not([disabled])')].filter((n) => n.offsetParent !== null);
        if (!f.length) return;
        if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      }

      /* ----- phone menu ----- */
      openMenu() {
        this._last = document.activeElement;
        this.classList.add('menu-open');
        document.documentElement.classList.add('adspoc-menu-open');
        document.documentElement.style.overflow = 'hidden';
        const b = this.querySelector('[data-hdr-menu-open]'); if (b) b.setAttribute('aria-expanded', 'true');
        setTimeout(() => { const x = this.menu.querySelector('[data-hdr-menu-close]'); if (x) x.focus(); }, 60);
      }
      closeMenu() {
        this.classList.remove('menu-open');
        document.documentElement.classList.remove('adspoc-menu-open');
        document.documentElement.style.overflow = '';
        const b = this.querySelector('[data-hdr-menu-open]'); if (b) b.setAttribute('aria-expanded', 'false');
        if (this._last && this._last.focus) this._last.focus({ preventScroll: true });
      }

      /* ----- tabs ----- */
      updateArrows() {
        const max = this.tabs.scrollWidth - this.tabs.clientWidth;
        const prev = this.querySelector('[data-tabs-step="-1"]');
        const next = this.querySelector('[data-tabs-step="1"]');
        if (prev) prev.hidden = max <= 4 || this.tabs.scrollLeft <= 4;
        if (next) next.hidden = max <= 4 || this.tabs.scrollLeft >= max - 4;
      }
      showPanel(tab) {
        if (!this.panelBox || isPhone()) return;
        const tpl = document.getElementById(tab.dataset.tabPanel);
        if (!tpl) return;
        if (this._tab && this._tab !== tab) this._tab.setAttribute('aria-expanded', 'false');
        this._tab = tab;
        tab.setAttribute('aria-expanded', 'true');
        this.panelBox.replaceChildren(tpl.content.cloneNode(true));
        this.panelBox.hidden = false;
        const navBox = this.panelBox.offsetParent ? this.panelBox.offsetParent.getBoundingClientRect() : { left: 0, width: window.innerWidth };
        const r = tab.getBoundingClientRect();
        const w = this.panelBox.offsetWidth;
        let left = r.left - navBox.left + r.width / 2 - w / 2;
        left = Math.max(12, Math.min(left, navBox.width - w - 12));
        this.panelBox.style.left = left + 'px';
      }
      queueHide() { clearTimeout(this._hideT); this._hideT = setTimeout(() => this.hidePanel(), 180); }
      hidePanel() {
        if (!this.panelBox) return;
        this.panelBox.hidden = true;
        if (this._tab) this._tab.setAttribute('aria-expanded', 'false');
        this._tab = null;
      }

      /* ----- search ----- */
      openSearch() {
        if (!this.form || this.form.classList.contains('is-open')) return;
        this.form.classList.add('is-open');
        this.classList.add('search-open');
        document.documentElement.classList.add('adspoc-search-open');
        document.documentElement.style.overflow = 'hidden';
        if (this.input.value.trim()) this.onType(); else this.renderIdle();
      }
      closeSearch() {
        if (!this.form) return;
        const wasOpen = this.form.classList.contains('is-open');
        this.form.classList.remove('is-open');
        this.classList.remove('search-open');
        document.documentElement.classList.remove('adspoc-search-open');
        this.results.hidden = true;
        this.input.setAttribute('aria-expanded', 'false');
        if (this.dim) this.dim.hidden = true;
        if (this._ctrl) this._ctrl.abort();
        if (wasOpen) document.documentElement.style.overflow = '';
      }
      renderIdle() {
        this.results.innerHTML = '<p class="adspoc-hdr__res-msg">Start typing to search ' + esc(this.input.placeholder.replace(/^search\s*/i, '')) + '</p>';
        this.results.hidden = false;
      }
      onType() {
        const q = this.input.value.trim();
        if (q && isPhone() && !this.form.classList.contains('is-open')) { this.openSearch(); return; }
        clearTimeout(this._t);
        if (this._ctrl) this._ctrl.abort();
        if (!q) { this.closeSearch(); return; }
        this.results.hidden = false;
        this.input.setAttribute('aria-expanded', 'true');
        if (this.dim && !isPhone()) this.dim.hidden = false;
        if (!this.results.querySelector('.adspoc-hdr__res-grid')) this.results.innerHTML = '<div class="adspoc-hdr__spin" aria-label="Searching"></div>';
        this._t = setTimeout(() => this.fetchResults(q), 220);
      }
      async fetchResults(q) {
        this._ctrl = new AbortController();
        const base = this.dataset.predictive || '/search/suggest';
        const url = base + '.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product,query,collection&resources[limit]=5&resources[options][unavailable_products]=last';
        try {
          const res = await nativeFetch()(url, { signal: this._ctrl.signal });
          if (!res.ok) throw new Error(res.status);
          const data = await res.json();
          this.render((data.resources && data.resources.results) || {}, q);
        } catch (e) {
          if (e.name !== 'AbortError') this.results.innerHTML = '<p class="adspoc-hdr__res-msg">Search is taking a break. Press Enter to see all results.</p>';
        }
      }
      render(r, q) {
        const products = r.products || [];
        const queries = (r.queries || []).filter((x) => x.text.toLowerCase() !== q.toLowerCase());
        const cols = r.collections || [];
        const all = (this.dataset.searchUrl || '/search') + '?q=' + encodeURIComponent(q) + '&type=product&options%5Bprefix%5D=last';
        if (!products.length && !queries.length && !cols.length) {
          this.results.innerHTML = '<p class="adspoc-hdr__res-msg">Nothing found for "' + esc(q) + '". Try a shorter word, like "chair" or "bin".</p>';
          return;
        }
        let side = '';
        if (queries.length) side += '<div><p class="adspoc-hdr__res-label">Search ideas</p>' + queries.slice(0, 5).map((x) => '<a href="' + esc(x.url) + '" data-res-item role="option">' + mark(x.text, q) + '</a>').join('') + '</div>';
        if (cols.length) side += '<div><p class="adspoc-hdr__res-label">Categories</p>' + cols.slice(0, 4).map((c) => '<a href="' + esc(c.url) + '" data-res-item role="option"><span>' + mark(c.title, q) + '</span></a>').join('') + '</div>';
        let main = '';
        products.forEach((p) => {
          const price = rupees(p.price);
          const cmp = p.compare_at_price_max && parseFloat(p.compare_at_price_max) > parseFloat(p.price) ? rupees(p.compare_at_price_max) : '';
          const varies = p.price_max && parseFloat(p.price_max) > parseFloat(p.price_min || p.price);
          main += '<a class="adspoc-hdr__res-prod" href="' + esc(p.url) + '" data-res-item role="option">' +
            '<span class="adspoc-hdr__res-img">' + (p.image ? '<img src="' + esc(p.image) + (p.image.includes('?') ? '&' : '?') + 'width=160" alt="" loading="lazy" width="64" height="64">' : '') + '</span>' +
            '<span class="adspoc-hdr__res-title">' + mark(p.title, q) + '</span>' +
            '<span class="adspoc-hdr__res-price">' + (varies ? '<small>From </small>' : '') + esc(price) + (cmp && !varies ? '<s>' + esc(cmp) + '</s>' : '') + '</span></a>';
        });
        main += '<a class="adspoc-hdr__res-all" href="' + esc(all) + '" data-res-item>See all results for "' + esc(q) + '" <span aria-hidden="true">→</span></a>';
        this.results.innerHTML = '<div class="adspoc-hdr__res-grid">' + (side ? '<div class="adspoc-hdr__res-side">' + side + '</div>' : '') + '<div class="adspoc-hdr__res-main"' + (side ? '' : ' style="grid-column: 1 / -1"') + '>' + main + '</div></div>';
      }
      searchKeys(e) {
        const items = [...this.results.querySelectorAll('[data-res-item]')];
        if (e.key === 'ArrowDown' && items.length) { e.preventDefault(); items[0].focus(); }
      }
    }
    customElements.define('adspoc-header', AdspocHeader);

    /* Arrow keys inside the results list */
    document.addEventListener('keydown', (e) => {
      const item = e.target.closest && e.target.closest('[data-res-item]');
      if (!item || (e.key !== 'ArrowDown' && e.key !== 'ArrowUp')) return;
      e.preventDefault();
      const list = [...item.closest('[data-hdr-results]').querySelectorAll('[data-res-item]')];
      const i = list.indexOf(item) + (e.key === 'ArrowDown' ? 1 : -1);
      if (i < 0) { const inp = item.closest('[data-hdr-search]').querySelector('[data-hdr-search-input]'); if (inp) inp.focus(); }
      else if (list[i]) list[i].focus();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["adspoc-faq"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('adspoc-faq')) return;
    const norm = (s) => (s || '').toLowerCase().normalize('NFKD').replace(/[̀-ͯ]/g, '').trim();

    class AdspocFaq extends HTMLElement {
      connectedCallback() {
        if (this._bound) return;
        this._bound = true;
        this.items = [...this.querySelectorAll('[data-faq-item]')];
        this.topics = [...this.querySelectorAll('[data-faq-topic]')];
        try { this.topicNames = JSON.parse((this.querySelector('[data-faq-topics]') || {}).textContent || '[]'); } catch (e) { this.topicNames = []; }
        this.items.forEach((it) => it.querySelectorAll('[data-faq-text]').forEach((t) => { t.dataset.raw = t.innerHTML; }));
        this.addEventListener('click', (e) => this.onClick(e));
        const search = this.querySelector('[data-faq-search]');
        if (search) search.addEventListener('input', () => { clearTimeout(this._t); this._t = setTimeout(() => this.filter(search.value), 120); });
        this.addEventListener('keydown', (e) => this.onKey(e));
        this.addEventListener('shopify:block:select', (e) => {
          const t = e.target.closest('[data-faq-topic]');
          if (t) { this.showTopic(Number(t.dataset.faqTopic)); return; }
          const it = e.target.closest('[data-faq-item]');
          if (it) { if (this.topics.length) this.showTopic(Number(it.dataset.topic)); this.toggle(it, true); }
        });
        if (this.topics.length) this.showTopic(0, true);
        this.setupOpenTag();
      }

      onClick(e) {
        const q = e.target.closest('[data-faq-toggle]');
        if (q) { this.toggle(q.closest('[data-faq-item]')); return; }
        const t = e.target.closest('[data-faq-topic]');
        if (t) { this.clearSearch(); this.showTopic(Number(t.dataset.faqTopic)); return; }
        if (e.target.closest('[data-faq-next]')) {
          const n = (this.current + 1) % this.topics.length;
          this.showTopic(n);
          const head = this.querySelector('[data-faq-head]');
          if (head && head.getBoundingClientRect().top < 0) head.scrollIntoView({ behavior: 'smooth', block: 'start' });
          return;
        }
        const v = e.target.closest('[data-faq-vote]');
        if (v) this.vote(v);
      }
      onKey(e) {
        const t = e.target.closest('[data-faq-topic]');
        if (!t || !['ArrowDown', 'ArrowUp', 'ArrowLeft', 'ArrowRight'].includes(e.key)) return;
        e.preventDefault();
        const i = this.topics.indexOf(t);
        const d = (e.key === 'ArrowDown' || e.key === 'ArrowRight') ? 1 : -1;
        const n = (i + d + this.topics.length) % this.topics.length;
        this.clearSearch(); this.showTopic(n); this.topics[n].focus();
      }

      /* one open at a time */
      toggle(item, force) {
        if (!item) return;
        const open = force !== undefined ? force : !item.classList.contains('is-open');
        if (open) this.items.forEach((it) => { if (it !== item) this.setOpen(it, false); });
        this.setOpen(item, open);
      }
      setOpen(item, open) {
        item.classList.toggle('is-open', open);
        const btn = item.querySelector('[data-faq-toggle]');
        const panel = item.querySelector('.adspoc-faq__a');
        if (btn) btn.setAttribute('aria-expanded', String(open));
        if (panel) panel.hidden = !open;
      }

      showTopic(i, first) {
        this.current = i;
        this.topics.forEach((t, k) => { t.setAttribute('aria-selected', String(k === i)); t.tabIndex = k === i ? 0 : -1; });
        let shown = 0; let firstItem = null;
        this.items.forEach((it) => {
          const on = Number(it.dataset.topic) === i;
          it.hidden = !on;
          if (on) { shown += 1; if (!firstItem) firstItem = it; }
        });
        const title = this.querySelector('[data-faq-group-title]');
        const aisle = this.querySelector('[data-faq-aisle]');
        const n = this.querySelector('[data-faq-group-n]');
        if (title) title.textContent = this.topicNames[i] || '';
        if (aisle) aisle.textContent = aisle.textContent.replace(/\d+$/, String(i + 1));
        if (n) n.textContent = shown + (shown === 1 ? ' question' : ' questions');
        const nextWrap = this.querySelector('[data-faq-next-wrap]');
        const next = this.querySelector('[data-faq-next]');
        if (next && nextWrap) {
          const ni = (i + 1) % this.topics.length;
          next.firstChild.textContent = (this.topicNames[ni] || '') + ' ';
          nextWrap.querySelector('i').textContent = ni === 0 ? nextWrap.dataset.back : nextWrap.dataset.label;
          nextWrap.hidden = false;
        }
        if (!first && firstItem) this.toggle(firstItem, true);
        if (first && firstItem && !this.items.some((it) => !it.hidden && it.classList.contains('is-open'))) this.toggle(firstItem, true);
        const t = this.topics[i];
        if (t && !first) t.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
        this.querySelector('[data-faq-none]').hidden = shown > 0;
      }

      clearSearch() {
        const s = this.querySelector('[data-faq-search]');
        if (s && s.value) { s.value = ''; this.filter(''); }
      }
      filter(raw) {
        const words = norm(raw).split(/\s+/).filter((w) => w.length > 1);
        const head = this.querySelector('[data-faq-head]');
        const res = this.querySelector('[data-faq-results]');
        const nextWrap = this.querySelector('[data-faq-next-wrap]');
        this.items.forEach((it) => it.querySelectorAll('[data-faq-text]').forEach((t) => { t.innerHTML = t.dataset.raw; }));
        if (!words.length) {
          this.classList.remove('is-searching');
          if (head) head.hidden = false;
          if (res) res.hidden = true;
          if (this.topics.length) this.showTopic(this.current || 0, true);
          else { this.items.forEach((it) => { it.hidden = false; }); this.querySelector('[data-faq-none]').hidden = true; }
          return;
        }
        this.classList.add('is-searching');
        if (head) head.hidden = true;
        if (nextWrap) nextWrap.hidden = true;
        let n = 0;
        this.items.forEach((it) => {
          const text = norm(it.textContent);
          const hit = words.every((w) => text.includes(w));
          it.hidden = !hit;
          if (hit) { n += 1; this.mark(it, words); }
        });
        const firstHit = this.items.find((it) => !it.hidden);
        this.items.forEach((it) => { if (it !== firstHit) this.setOpen(it, false); });
        if (firstHit) this.setOpen(firstHit, true);
        if (res) { res.hidden = false; res.textContent = n === 1 ? '1 question matches' : n + ' questions match'; }
        this.querySelector('[data-faq-none]').hidden = n > 0;
      }
      /* highlight matched words inside text nodes only */
      mark(item, words) {
        const src = '(' + words.map((w) => w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|') + ')';
        const re = new RegExp(src, 'gi'); const hasHit = new RegExp(src, 'i');
        item.querySelectorAll('[data-faq-text]').forEach((root) => {
          const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
          const nodes = []; while (walker.nextNode()) nodes.push(walker.currentNode);
          nodes.forEach((node) => {
            if (!hasHit.test(node.nodeValue)) return;
            const span = document.createElement('span');
            span.innerHTML = node.nodeValue.replace(/[&<>]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;' }[c])).replace(re, '<mark>$1</mark>');
            node.replaceWith(...span.childNodes);
          });
        });
      }

      vote(btn) {
        const wrap = btn.closest('[data-faq-fb]');
        const item = btn.closest('[data-faq-item]');
        const q = item ? (item.querySelector('[data-faq-toggle] [data-faq-text]') || {}).textContent : '';
        const helpful = btn.dataset.faqVote === 'yes';
        const detail = { question: (q || '').trim(), helpful, page: location.pathname };
        try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('adspoc_faq_feedback', detail); } catch (e) {}
        try { if (typeof window.gtag === 'function') window.gtag('event', 'faq_feedback', detail); else if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event: 'faq_feedback', ...detail }); } catch (e) {}
        if (wrap) { wrap.classList.add('is-done'); wrap.textContent = helpful ? 'Thanks! Glad it helped.' : 'Thanks. We will make this answer clearer.'; }
      }

      /* "Open now / Closed now" from the hours, India time (same logic as the footer) */
      setupOpenTag() {
        const card = this.querySelector('.adspoc-faq__counter');
        if (!card) return;
        const open = Number(card.dataset.open); const close = Number(card.dataset.close);
        if (!(close > open)) return;
        try {
          const parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Asia/Kolkata', weekday: 'short', hour: 'numeric', minute: 'numeric', hourCycle: 'h23' }).formatToParts(new Date());
          const get = (t) => (parts.find((p) => p.type === t) || {}).value;
          const h = Number(get('hour')) + Number(get('minute')) / 60;
          const day = (get('weekday') || '').toLowerCase().slice(0, 3);
          const isOpen = day !== (card.dataset.closedDay || '').slice(0, 3) && h >= open && h < close;
          this.querySelectorAll('[data-faq-open]').forEach((b) => { b.textContent = isOpen ? 'Open now' : 'Closed now'; b.classList.toggle('is-closed', !isOpen); b.hidden = false; });
        } catch (e) { /* leave hidden */ }
      }
    }
    customElements.define('adspoc-faq', AdspocFaq);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["adspoc-footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    /* Footer: aisles fold on phones, stay open on desktop; "Open now / Closed now" from the store hours (India time) */
    const phone = window.matchMedia('(max-width: 749px)');
    const setup = (ft) => {
      const sync = () => ft.querySelectorAll('.adspoc-ft__col').forEach((d) => { d.open = !phone.matches; });
      sync();
      if (!ft._ftBound) {
        ft._ftBound = true;
        phone.addEventListener('change', sync);
        ft.addEventListener('click', (e) => {
          const s = e.target.closest('.adspoc-ft__col-head');
          if (s && !phone.matches) e.preventDefault(); /* desktop: columns can't be folded */
        });
      }
      const open = Number(ft.dataset.open); const close = Number(ft.dataset.close);
      const badges = ft.querySelectorAll('[data-ft-open]');
      if (!badges.length || !(close > open)) return;
      try {
        const parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Asia/Kolkata', weekday: 'short', hour: 'numeric', minute: 'numeric', hourCycle: 'h23' }).formatToParts(new Date());
        const get = (t) => (parts.find((p) => p.type === t) || {}).value;
        const h = Number(get('hour')) + Number(get('minute')) / 60;
        const day = (get('weekday') || '').toLowerCase().slice(0, 3);
        const isOpen = day !== (ft.dataset.closedDay || '').slice(0, 3) && h >= open && h < close;
        badges.forEach((b) => { b.textContent = isOpen ? 'Open now' : 'Closed now'; b.classList.toggle('is-closed', !isOpen); b.hidden = false; });
      } catch (e) { /* leave hidden */ }
    };
    const run = () => document.querySelectorAll('.adspoc-ft').forEach(setup);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["adspoc-main-article"]) return;
  try {
    
  if (!customElements.get('adspoc-article')) {
    customElements.define('adspoc-article', class extends HTMLElement {
      connectedCallback() {
        this.content = this.querySelector('[data-ar-content]');
        this.bar = this.querySelector('[data-ar-progress]');
        this.buildToc();
        this.onScroll = () => { if (!this.raf) this.raf = requestAnimationFrame(() => { this.raf = null; this.update(); }); };
        addEventListener('scroll', this.onScroll, { passive: true });
        addEventListener('resize', this.onScroll, { passive: true });
        this.update();
        this.querySelectorAll('[data-ar-copy]').forEach((b) => b.addEventListener('click', () => this.copy(b)));
      }
      disconnectedCallback() { removeEventListener('scroll', this.onScroll); removeEventListener('resize', this.onScroll); }

      buildToc() {
        if (!this.content) return;
        const heads = [...this.content.querySelectorAll('h2, h3')].filter((h) => h.textContent.trim());
        this.heads = heads;
        if (heads.filter((h) => h.tagName === 'H2').length < 2 && heads.length < 3) return;
        const used = {};
        heads.forEach((h, i) => {
          if (!h.id) {
            let id = h.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 60) || 'part-' + (i + 1);
            if (used[id]) id += '-' + i;
            used[id] = 1;
            h.id = id;
          }
        });
        this.querySelectorAll('[data-ar-toc-list]').forEach((ol) => {
          ol.innerHTML = '';
          heads.forEach((h) => {
            const li = document.createElement('li');
            if (h.tagName === 'H3') li.className = 'is-sub';
            const a = document.createElement('a');
            a.href = '#' + h.id;
            a.textContent = h.textContent.trim();
            a.addEventListener('click', () => { const m = this.querySelector('[data-ar-toc-m]'); if (m) m.open = false; });
            li.append(a);
            ol.append(li);
          });
        });
        const side = this.querySelector('[data-ar-side]');
        const mob = this.querySelector('[data-ar-toc-m]');
        if (side) side.hidden = false;
        if (mob) mob.hidden = false;
        this.links = [...this.querySelectorAll('.adspoc-ar__toc a')];
      }

      update() {
        if (this.content && this.bar) {
          const r = this.content.getBoundingClientRect();
          const total = r.height - innerHeight * 0.6;
          const done = Math.min(1, Math.max(0, (innerHeight * 0.4 - r.top) / Math.max(total, 1)));
          this.bar.style.transform = 'scaleX(' + done + ')';
        }
        if (this.links && this.links.length) {
          let cur = 0;
          this.heads.forEach((h, i) => { if (h.getBoundingClientRect().top < innerHeight * 0.3) cur = i; });
          this.links.forEach((a, i) => a.classList.toggle('is-on', i === cur));
        }
      }

      copy(b) {
        const url = b.dataset.arCopy;
        const show = () => { const t = b.querySelector('[data-ar-copied]'); if (!t) return; t.hidden = false; clearTimeout(b._t); b._t = setTimeout(() => { t.hidden = true; }, 1600); };
        if (navigator.share && matchMedia('(pointer: coarse)').matches) { navigator.share({ title: document.title, url }).catch(() => {}); return; }
        if (navigator.clipboard) navigator.clipboard.writeText(url).then(show, show); else show();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["adspoc-main-cart"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('adspoc-cart-page')) return;
    const nativeFetch = (...a) => (window.__adspocNativeFetch || window.fetch.bind(window))(...a);
    const root = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    class AdspocCartPage extends HTMLElement {
      connectedCallback() {
        if (this._bound) return;
        this._bound = true;
        this.id_ = this.dataset.sectionId;
        this.addEventListener('click', (e) => this.onClick(e));
        this.addEventListener('scroll', (e) => {
          if (!e.target.matches || !e.target.matches('[data-cp-track]')) return;
          cancelAnimationFrame(this._raf);
          this._raf = requestAnimationFrame(() => this.syncArrows());
        }, true);
        this.onOutside = () => { if (Date.now() > (this._selfUntil || 0)) this.reload(); };
        document.addEventListener('cart:updated', this.onOutside);
        this.onResize = () => this.syncArrows();
        window.addEventListener('resize', this.onResize);
        const note = this.querySelector('[data-cp-note]');
        if (note) note.addEventListener('input', () => { clearTimeout(this._noteT); this._noteT = setTimeout(() => this.saveNote(note.value), 700); });
        this.watchCheckout();
        this.loadRecs();
        requestAnimationFrame(() => this.syncArrows());
      }
      disconnectedCallback() {
        document.removeEventListener('cart:updated', this.onOutside);
        window.removeEventListener('resize', this.onResize);
        if (this._mo) this._mo.disconnect();
        this._bound = false;
      }

      onClick(e) {
        const q = e.target.closest('[data-cart-qty]');
        if (q && this.contains(q)) { e.preventDefault(); this.change(q.dataset.key, Number(q.dataset.qty)); return; }
        const step = e.target.closest('[data-cp-step]');
        if (step) {
          const band = step.closest('.adspoc-cp__band');
          this.stepTrack(band && band.querySelector('[data-cp-track]'), Number(step.dataset.cpStep));
        }
      }

      /* Quantity / remove: Shopify re-renders this section; the checkout area is left alone */
      async change(key, qty) {
        if (this.getAttribute('aria-busy') === 'true') return;
        this.setAttribute('aria-busy', 'true');
        this.showError('');
        try {
          const res = await nativeFetch(root() + 'cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: key, quantity: qty, sections: [this.id_], sections_url: window.location.pathname })
          });
          const data = await res.json();
          if (!res.ok) { this.showError(data.description || data.message || 'Could not update the cart. Please try again.'); return; }
          if (data.item_count === 0) { window.location.reload(); return; }
          const html = data.sections && data.sections[this.id_];
          if (html) this.swap(html); else await this.reload();
          this.tellOthers();
        } catch (err) {
          this.showError('Could not update the cart. Please check your connection.');
        } finally {
          this.removeAttribute('aria-busy');
        }
      }
      async reload() {
        try {
          const res = await nativeFetch(root() + 'cart?section_id=' + encodeURIComponent(this.id_));
          if (!res.ok) return;
          const html = await res.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const wasEmpty = !this.querySelector('[data-cp-swap="items"]');
          const nowEmpty = !doc.querySelector('[data-cp-swap="items"]');
          if (wasEmpty !== nowEmpty) { window.location.reload(); return; }
          this.swap(html);
        } catch (e) { /* leave the page as it is */ }
      }
      /* Replace every [data-cp-swap] part with the fresh one; product cards and checkout stay */
      swap(html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('adspoc-cart-page');
        if (!fresh) return;
        this.querySelectorAll('[data-cp-swap]').forEach((el) => {
          const b = fresh.querySelector(`[data-cp-swap="${el.dataset.cpSwap}"]`);
          if (b) el.replaceWith(b);
        });
      }
      tellOthers() {
        this._selfUntil = Date.now() + 2500;
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      }
      showError(msg) {
        const el = this.querySelector('[data-cp-error]');
        if (!el) return;
        el.textContent = msg; el.hidden = !msg;
      }
      async saveNote(note) {
        const status = this.querySelector('[data-cp-note-status]');
        try {
          const res = await nativeFetch(root() + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ note }) });
          if (status) status.textContent = res.ok ? 'Saved' : 'Could not save the note';
        } catch (e) { if (status) status.textContent = 'Could not save the note'; }
      }

      /* Checkout: show the store's own button only if the checkout app hasn't put one in its slot */
      watchCheckout() {
        const native = this.querySelector('[data-cp-native]');
        const slot = this.querySelector('[data-cp-sr]');
        if (!native || !slot) return;
        const update = () => { native.hidden = slot.children.length > 0; };
        this._mo = new MutationObserver(update);
        this._mo.observe(slot, { childList: true });
        setTimeout(() => { if (!slot.children.length) native.hidden = false; }, 3000);
      }

      /* Product cards from Shopify's recommendations, rendered by this same section */
      async loadRecs() {
        const box = this.querySelector('[data-cp-recs]');
        if (!box || box.innerHTML.trim() || !box.dataset.productId) return;
        try {
          const url = root() + 'recommendations/products?product_id=' + encodeURIComponent(box.dataset.productId) +
            '&limit=' + (Number(this.dataset.recLimit || 6) + 3) + '&intent=' + encodeURIComponent(this.dataset.recIntent || 'related') +
            '&section_id=' + encodeURIComponent(this.id_);
          const res = await nativeFetch(url);
          if (!res.ok) return;
          const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
          const got = doc.querySelector('[data-cp-recs]');
          box.innerHTML = got ? got.innerHTML.trim() : '';
          this.syncArrows();
        } catch (e) { /* no cards, no problem */ }
      }

      /* Arrows: off at the ends, hidden when everything fits */
      stepTrack(track, dir) {
        if (!track || !track.firstElementChild) return;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 16;
        const w = track.firstElementChild.getBoundingClientRect().width + gap;
        const max = track.scrollWidth - track.clientWidth;
        track.scrollTo({ left: Math.max(0, Math.min(max, track.scrollLeft + dir * w)), behavior: 'smooth' });
      }
      syncArrows() {
        this.querySelectorAll('.adspoc-cp__band').forEach((band) => {
          const track = band.querySelector('[data-cp-track]');
          const arrows = band.querySelector('.adspoc-cp__arrows');
          if (!track || !arrows) return;
          const max = track.scrollWidth - track.clientWidth;
          const [prev, next] = arrows.querySelectorAll('button');
          arrows.hidden = max <= 4;
          if (prev) prev.disabled = track.scrollLeft <= 4;
          if (next) next.disabled = track.scrollLeft >= max - 4;
        });
      }
    }
    customElements.define('adspoc-cart-page', AdspocCartPage);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["adspoc-main-search"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__adspocSearchPage) return;
    window.__adspocSearchPage = true;
    const esc = (s) => s.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');

    /* Highlight the search words in product names (and again after filters re-render the grid) */
    function highlight(box) {
      const host = box.closest('[data-search-terms]');
      const words = ((host && host.dataset.searchTerms) || '').split(/\s+/).filter((w) => w.length > 1);
      if (!words.length) return;
      const re = new RegExp('(' + words.map(esc).join('|') + ')', 'gi');
      box.querySelectorAll('.adspoc-card__title a').forEach((a) => {
        if (a.dataset.hl) return;
        a.dataset.hl = '1';
        const text = a.textContent;
        if (!re.test(text)) return;
        re.lastIndex = 0;
        a.innerHTML = text.replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c])).replace(re, '<mark class="adspoc-hl">$1</mark>');
      });
    }
    function scan() { document.querySelectorAll('[data-search-results]').forEach(highlight); }
    const mo = new MutationObserver(scan);
    const start = () => { scan(); document.querySelectorAll('[data-search-terms]').forEach((el) => mo.observe(el, { childList: true, subtree: true })); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();

    /* Product row arrows on the no-results page: off at the ends, hidden when everything fits */
    function syncBand(band) {
      const track = band.querySelector('[data-sr-track]');
      const arrows = band.querySelector('.adspoc-cp__arrows');
      if (!track || !arrows) return;
      const max = track.scrollWidth - track.clientWidth;
      const [prev, next] = arrows.querySelectorAll('button');
      arrows.hidden = max <= 4;
      prev.disabled = track.scrollLeft <= 4;
      next.disabled = track.scrollLeft >= max - 4;
    }
    const bands = () => document.querySelectorAll('.adspoc-sr__band');
    document.addEventListener('click', (e) => {
      const b = e.target.closest('.adspoc-sr__band [data-cp-step]');
      if (!b) return;
      const track = b.closest('.adspoc-sr__band').querySelector('[data-sr-track]');
      if (!track || !track.firstElementChild) return;
      const w = track.firstElementChild.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 16);
      const max = track.scrollWidth - track.clientWidth;
      track.scrollTo({ left: Math.max(0, Math.min(max, track.scrollLeft + Number(b.dataset.cpStep) * w)), behavior: 'smooth' });
    });
    document.addEventListener('scroll', (e) => { if (e.target.matches && e.target.matches('[data-sr-track]')) syncBand(e.target.closest('.adspoc-sr__band')); }, true);
    window.addEventListener('resize', () => bands().forEach(syncBand));
    const init = () => bands().forEach(syncBand);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["adspoc-photo-wall"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('adspoc-photo-wall')) {
    customElements.define('adspoc-photo-wall', class extends HTMLElement {
      connectedCallback() {
        this.rows = [...this.querySelectorAll('[data-pw-row]')];
        this.build = this.build.bind(this);
        this.build();
        this.ro = new ResizeObserver(() => { clearTimeout(this.t); this.t = setTimeout(this.build, 150); });
        this.ro.observe(this);
        this.io = new IntersectionObserver((es) => es.forEach((e) => this.rows.forEach((r) => {
          const t = r.querySelector('[data-pw-track]');
          if (t) t.style.animationPlayState = e.isIntersecting ? '' : 'paused';
        })), { rootMargin: '100px' });
        this.io.observe(this);
        this.querySelectorAll('img').forEach((img) => { if (!img.complete) img.addEventListener('load', () => { clearTimeout(this.t); this.t = setTimeout(this.build, 150); }, { once: true }); });
      }
      disconnectedCallback() { if (this.ro) this.ro.disconnect(); if (this.io) this.io.disconnect(); }

      build() {
        const speed = parseFloat(getComputedStyle(this).getPropertyValue('--pw-speed')) || 50;
        const vw = this.getBoundingClientRect().width || innerWidth;
        this.rows.forEach((row) => {
          const track = row.querySelector('[data-pw-track]');
          if (!track) return;
          if (getComputedStyle(row).display === 'none') return;
          track.querySelectorAll('[data-pw-clone]').forEach((c) => c.remove());
          track.classList.remove('is-moving');
          const originals = [...track.children];
          if (!originals.length) return;
          const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
          const setW = track.scrollWidth + gap;
          if (setW < 10) return;
          /* repeat the set until the track is at least one set + one screen wide, then slide by exactly one set */
          const copies = Math.max(1, Math.ceil((vw + setW) / setW));
          for (let i = 0; i < copies; i += 1) {
            originals.forEach((li) => {
              const c = li.cloneNode(true);
              c.setAttribute('data-pw-clone', '');
              c.setAttribute('aria-hidden', 'true');
              c.removeAttribute('data-shopify-editor-block');
              track.append(c);
            });
          }
          const pxPerSec = speed * (parseFloat(row.dataset.speed) || 1) * 0.9;
          track.style.setProperty('--pw-dist', setW + 'px');
          track.style.setProperty('--pw-dur', (setW / Math.max(pxPerSec, 5)).toFixed(2) + 's');
          track.classList.add('is-moving');
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["adspoc-product-showcase"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('adspoc-showcase')) return;
    class AdspocShowcase extends HTMLElement {
      connectedCallback() {
        if (this._bound) return;
        this._bound = true;
        this.tabs = [...this.querySelectorAll('[data-ps-tab]')];
        this.addEventListener('click', (e) => {
          const t = e.target.closest('[data-ps-tab]');
          if (t) { this.select(Number(t.dataset.psTab), false); return; }
          const s = e.target.closest('[data-ps-step]');
          if (s) this.step(Number(s.dataset.psStep));
        });
        this.addEventListener('keydown', (e) => {
          const t = e.target.closest('[data-ps-tab]');
          if (!t) return;
          const i = this.tabs.indexOf(t);
          let n = null;
          if (e.key === 'ArrowRight') n = (i + 1) % this.tabs.length;
          else if (e.key === 'ArrowLeft') n = (i - 1 + this.tabs.length) % this.tabs.length;
          else if (e.key === 'Home') n = 0;
          else if (e.key === 'End') n = this.tabs.length - 1;
          if (n === null) return;
          e.preventDefault();
          this.select(n, true);
        });
        this.addEventListener('scroll', () => { cancelAnimationFrame(this._raf); this._raf = requestAnimationFrame(() => this.sync()); }, true);
        this._onResize = () => this.sync();
        window.addEventListener('resize', this._onResize);
        /* Theme editor: selecting a tab block shows that tab */
        this.addEventListener('shopify:block:select', (e) => {
          const t = e.target.closest('[data-ps-tab]');
          if (t) this.select(Number(t.dataset.psTab), false);
        });
        requestAnimationFrame(() => this.sync());
      }
      disconnectedCallback() { window.removeEventListener('resize', this._onResize); this._bound = false; }

      panel() { return this.querySelector('[data-ps-panel]:not([hidden])'); }
      select(i, focus) {
        this.tabs.forEach((t, k) => {
          const on = k === i;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          if (on && focus) t.focus();
          if (on) t.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
        });
        this.querySelectorAll('[data-ps-panel]').forEach((p) => { p.hidden = Number(p.dataset.psPanel) !== i; });
        this.querySelectorAll('[data-ps-all]').forEach((a) => { a.hidden = Number(a.dataset.psAll) !== i; });
        const track = this.panel() && this.panel().querySelector('[data-ps-track]');
        if (track) track.scrollLeft = 0;
        this.sync();
      }
      step(dir) {
        const track = this.panel() && this.panel().querySelector('[data-ps-track]');
        if (!track || !track.firstElementChild) return;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 20;
        const w = track.firstElementChild.getBoundingClientRect().width + gap;
        const max = track.scrollWidth - track.clientWidth;
        track.scrollTo({ left: Math.max(0, Math.min(max, track.scrollLeft + dir * w)), behavior: 'smooth' });
      }
      sync() {
        const arrows = this.querySelector('.adspoc-ps__arrows');
        const track = this.panel() && this.panel().querySelector('[data-ps-track]');
        if (!arrows || !track) return;
        const max = track.scrollWidth - track.clientWidth;
        const [prev, next] = arrows.querySelectorAll('button');
        arrows.hidden = max <= 4;
        prev.disabled = track.scrollLeft <= 4;
        next.disabled = track.scrollLeft >= max - 4;
      }
    }
    customElements.define('adspoc-showcase', AdspocShowcase);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
